import { useEffect, useState } from "react"
import { Box, Button, Heading, Spinner } from "@chakra-ui/react"

import {
    getLinesForCreatorMap,
    getMarkersForCreatorMap,
    getTileLayerForSelectedBackground,
    getZoomForCountryCode,
} from "../../utilities/mappingHelper"


import MapDisplay from "../../components/mapping/MapDisplay"

export default function CreatorMap({ creatorMap, isScrollWheelZoomDisabled }) {

    const [mapProps, setMapProps] = useState({
        defaultCenter: undefined,
        tileLayer: undefined,
        isWatermarkDisabled: undefined,
    })

    // Loading map attributes and displaying
    const [mapLines, setMapLines] = useState({
        existing: [],
        preview: [],
    })
    const [mapPoints, setMapPoints] = useState([])
    const [previewPoints, setPreviewPoints] = useState({})

    useEffect(() => {
        if (!creatorMap)
            return

        setMapProps({
            // defaultCenter: user.details.homeCountry ? getZoomForCountryCode(user.details.homeCountry.code) : undefined,
            defaultCenter: [48.8566, 2.3522],
            tileLayer: getTileLayerForSelectedBackground(creatorMap.background),
            isWatermarkDisabled: !creatorMap.watermark,
            isScrollWheelZoomDisabled: isScrollWheelZoomDisabled,
        })

        setMapLines({
            existing: getLinesForCreatorMap(creatorMap),
            preview: [],
        })

        setMapPoints(getMarkersForCreatorMap(creatorMap))
    }, [creatorMap])

    useEffect(() => {
        console.log(mapProps)
    }, [mapProps])

    // TODO: Tidy this up
    if (mapProps.tileLayer === undefined)
        return <Spinner />

    return (
        <MapDisplay
            defaultCenter={mapProps.defaultCenter}
            tileLayer={mapProps.tileLayer}

            lines={mapLines}
            points={mapPoints}
            previewPoints={previewPoints}

            isWatermarkDisabled={mapProps.isWatermarkDisabled}
            isImageDownloadDisabled
            isScrollWheelZoomDisabled={mapProps.isScrollWheelZoomDisabled}
        />
    )

}